// ============================================================================
// Entity: Teams
// Key: teams
// Kind: entity
// Generated file. Do not edit manually.
// ============================================================================

import {
	getCustomPagesListQueryKey,
	getPauseReasonsListQueryKey,
	getQueuesListQueryKey,
	getSkillGroupsListQueryKey,
	getSkillsListQueryKey,
	getTeamsClientGetQueryKey,
	getTeamsClientGetQueryOptions,
	getTeamsDetailQueryKey,
	getTeamsDetailQueryOptions,
	getTeamsListQueryKey,
	getTeamsListQueryOptions,
	getTeamsRelationsCustomPagesAssignedQueryKey,
	getTeamsRelationsCustomPagesAssignedQueryOptions,
	getTeamsRelationsCustomPagesAvailableQueryKey,
	getTeamsRelationsCustomPagesAvailableQueryOptions,
	getTeamsRelationsPauseReasonsAssignedQueryKey,
	getTeamsRelationsPauseReasonsAssignedQueryOptions,
	getTeamsRelationsPauseReasonsAvailableQueryKey,
	getTeamsRelationsPauseReasonsAvailableQueryOptions,
	getTeamsRelationsQueuesAssignedQueryKey,
	getTeamsRelationsQueuesAssignedQueryOptions,
	getTeamsRelationsQueuesAvailableQueryKey,
	getTeamsRelationsQueuesAvailableQueryOptions,
	getTeamsRelationsSkillGroupsAssignedQueryKey,
	getTeamsRelationsSkillGroupsAssignedQueryOptions,
	getTeamsRelationsSkillGroupsAvailableQueryKey,
	getTeamsRelationsSkillGroupsAvailableQueryOptions,
	getTeamsRelationsSkillsAssignedQueryKey,
	getTeamsRelationsSkillsAssignedQueryOptions,
	getTeamsRelationsSkillsAvailableQueryKey,
	getTeamsRelationsSkillsAvailableQueryOptions,
	getTeamsRelationsUsersAssignedQueryKey,
	getTeamsRelationsUsersAssignedQueryOptions,
	getTeamsRelationsUsersAvailableQueryKey,
	getTeamsRelationsUsersAvailableQueryOptions,
	getTeamsSettingsContactLoadQueryKey,
	getTeamsSettingsContactLoadQueryOptions,
	getTeamsSettingsGeneralLoadQueryKey,
	getTeamsSettingsGeneralLoadQueryOptions,
	getTeamsSettingsLoginLoadQueryKey,
	getTeamsSettingsLoginLoadQueryOptions,
	getTeamsSettingsPhoneLoadQueryKey,
	getTeamsSettingsPhoneLoadQueryOptions,
	getTeamsSettingsRecordingLoadQueryKey,
	getTeamsSettingsRecordingLoadQueryOptions,
	getTeamsSettingsSetclipLoadQueryKey,
	getTeamsSettingsSetclipLoadQueryOptions,
	getTemplatesListQueryKey,
	getUsersListQueryKey,
	teamsCreate,
	teamsDelete,
	teamsRelationsCustomPagesAssign,
	teamsRelationsCustomPagesUnassign,
	teamsRelationsPauseReasonsAssign,
	teamsRelationsPauseReasonsUnassign,
	teamsRelationsQueuesAssign,
	teamsRelationsQueuesUnassign,
	teamsRelationsQueuesUpdate,
	teamsRelationsSkillGroupsAssign,
	teamsRelationsSkillGroupsUnassign,
	teamsRelationsSkillsAssign,
	teamsRelationsSkillsUnassign,
	teamsRelationsTemplatesUpdate,
	teamsRelationsUsersAssign,
	teamsRelationsUsersUnassign,
	teamsSettingsContactReset,
	teamsSettingsContactUpdate,
	teamsSettingsGeneralReset,
	teamsSettingsGeneralUpdate,
	teamsSettingsLoginReset,
	teamsSettingsLoginUpdate,
	teamsSettingsPhoneReset,
	teamsSettingsPhoneUpdate,
	teamsSettingsRecordingReset,
	teamsSettingsRecordingUpdate,
	teamsSettingsSetclipReset,
	teamsSettingsSetclipUpdate,
	teamsUpdate,
} from '../api/backstage'
// #region Imports
import type {
	ContactSettingsDto,
	CreateOrUpdateContactSettingsRequest,
	CreateOrUpdateGeneralSettingsRequest,
	CreateOrUpdateLoginSettingsRequest,
	CreateOrUpdatePhoneSettingsRequest,
	CreateOrUpdateRecordingSettingsRequest,
	CreateOrUpdateSetClipSettingsRequest,
	CreateOrUpdateTeamRequest,
	GeneralSettingsDto,
	LoginSettingsDto,
	PagedResultOfCustomPageDto,
	PagedResultOfPauseReasonSummary,
	PagedResultOfQueueSummary,
	PagedResultOfSkillGroupSummary,
	PagedResultOfSkillSummary,
	PagedResultOfTeamCustomPageResponse,
	PagedResultOfTeamPauseReasonResponse,
	PagedResultOfTeamQueueResponse,
	PagedResultOfTeamSkillGroupResponse,
	PagedResultOfTeamSkillResponse,
	PagedResultOfTeamSummary,
	PagedResultOfTeamUserDto,
	PagedResultOfUserDto,
	PhoneSettingsDto,
	RecordingSettingsDto,
	SetClipSettingsDto,
	TeamCustomPageResponse,
	TeamDetails,
	TeamPauseReasonResponse,
	TeamQueueResponse,
	TeamSkillGroupResponse,
	TeamSkillResponse,
	TeamSummary,
	TeamUserDto,
	UpdateTeamQueueRequest,
} from '../api/backstage.schemas'
import type { EntityConfig, ListQueryParams } from './entity-config.types'
import {
	defineMutationEndpoint,
	defineQueryEndpoint,
} from './entity-config.types'

// #endregion

// #region Entity Endpoints
const teamsEntityEndpoints = {
	create: defineMutationEndpoint<
		TeamSummary,
		CreateOrUpdateTeamRequest,
		undefined
	>({
		key: 'teams.create',
		method: 'POST',
		path: '/admin/teams',
		mutationOptions: () => ({
			mutationFn: (variables: { data: CreateOrUpdateTeamRequest }) =>
				teamsCreate(variables.data),
		}),
		invalidates: [(_context) => getTeamsListQueryKey()],
	}),
	delete: defineMutationEndpoint<void, undefined, { teamId: number }>({
		key: 'teams.delete',
		method: 'DELETE',
		path: '/admin/teams/{teamId}',
		pathParams: ['teamId'] as const,
		mutationOptions: () => ({
			mutationFn: (variables: { teamId: number | string | null | undefined }) =>
				teamsDelete(variables.teamId),
		}),
		invalidates: [(_context) => getTeamsListQueryKey()],
	}),
	detail: defineQueryEndpoint<TeamDetails, { teamId: number }, undefined>({
		key: 'teams.detail',
		method: 'GET',
		path: '/admin/teams/{teamId}',
		pathParams: ['teamId'] as const,
		queryKey: (args) => getTeamsDetailQueryKey(args?.pathParams?.teamId),
		queryOptions: (args) =>
			getTeamsDetailQueryOptions(args?.pathParams?.teamId),
	}),
	list: defineQueryEndpoint<
		PagedResultOfTeamSummary,
		undefined,
		ListQueryParams
	>({
		key: 'teams.list',
		method: 'GET',
		path: '/admin/teams',
		queryKey: (args) => getTeamsListQueryKey(args?.queryParams),
		queryOptions: (args) => getTeamsListQueryOptions(args?.queryParams),
	}),
	update: defineMutationEndpoint<
		TeamSummary,
		CreateOrUpdateTeamRequest,
		{ teamId: number }
	>({
		key: 'teams.update',
		method: 'PUT',
		path: '/admin/teams/{teamId}',
		pathParams: ['teamId'] as const,
		mutationOptions: () => ({
			mutationFn: (variables: {
				teamId: number | string | null | undefined
				data: CreateOrUpdateTeamRequest
			}) => teamsUpdate(variables.teamId, variables.data),
		}),
		invalidates: [
			(_context) => getTeamsListQueryKey(),
			(context) => getTeamsDetailQueryKey(context.entityId ?? context.ownerId),
		],
	}),
} as const
// #endregion

// #region Relations
// #region Relation: CustomPages
// Target Entity: customPages
const teamsCustomPagesRelation = {
	key: 'customPages',
	targetEntity: 'customPages',
	endpoints: {
		assign: defineMutationEndpoint<
			TeamCustomPageResponse[],
			(number | string)[],
			{ teamId: number }
		>({
			key: 'teams.relations.customPages.assign',
			method: 'POST',
			path: '/admin/teams/{teamId}/custompages',
			pathParams: ['teamId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					teamId: number | string | null | undefined
					data: (number | string)[]
				}) => teamsRelationsCustomPagesAssign(variables.teamId, variables.data),
			}),
			invalidates: [
				(context) =>
					getTeamsRelationsCustomPagesAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getTeamsRelationsCustomPagesAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getTeamsListQueryKey(),
				(_context) => getCustomPagesListQueryKey(),
			],
		}),
		assigned: defineQueryEndpoint<
			PagedResultOfTeamCustomPageResponse,
			{ teamId: number },
			ListQueryParams
		>({
			key: 'teams.relations.customPages.assigned',
			method: 'GET',
			path: '/admin/teams/{teamId}/custompages',
			pathParams: ['teamId'] as const,
			queryKey: (args) =>
				getTeamsRelationsCustomPagesAssignedQueryKey(
					args?.pathParams?.teamId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getTeamsRelationsCustomPagesAssignedQueryOptions(
					args?.pathParams?.teamId,
					args?.queryParams,
				),
		}),
		available: defineQueryEndpoint<
			PagedResultOfCustomPageDto,
			{ teamId: number },
			ListQueryParams
		>({
			key: 'teams.relations.customPages.available',
			method: 'GET',
			path: '/admin/teams/{teamId}/assignable-custompages',
			pathParams: ['teamId'] as const,
			queryKey: (args) =>
				getTeamsRelationsCustomPagesAvailableQueryKey(
					args?.pathParams?.teamId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getTeamsRelationsCustomPagesAvailableQueryOptions(
					args?.pathParams?.teamId,
					args?.queryParams,
				),
		}),
		unassign: defineMutationEndpoint<
			void,
			(number | string)[],
			{ teamId: number }
		>({
			key: 'teams.relations.customPages.unassign',
			method: 'DELETE',
			path: '/admin/teams/{teamId}/custompages',
			pathParams: ['teamId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					teamId: number | string | null | undefined
					data: (number | string)[]
				}) =>
					teamsRelationsCustomPagesUnassign(variables.teamId, variables.data),
			}),
			invalidates: [
				(context) =>
					getTeamsRelationsCustomPagesAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getTeamsRelationsCustomPagesAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getTeamsListQueryKey(),
				(_context) => getCustomPagesListQueryKey(),
			],
		}),
	},
} as const
// #endregion

// #region Relation: PauseReasons
// Target Entity: pauseReasons
const teamsPauseReasonsRelation = {
	key: 'pauseReasons',
	targetEntity: 'pauseReasons',
	endpoints: {
		assign: defineMutationEndpoint<
			TeamPauseReasonResponse[],
			(number | string)[],
			{ teamId: number }
		>({
			key: 'teams.relations.pauseReasons.assign',
			method: 'POST',
			path: '/admin/teams/{teamId}/pausereasons',
			pathParams: ['teamId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					teamId: number | string | null | undefined
					data: (number | string)[]
				}) =>
					teamsRelationsPauseReasonsAssign(variables.teamId, variables.data),
			}),
			invalidates: [
				(context) =>
					getTeamsRelationsPauseReasonsAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getTeamsRelationsPauseReasonsAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getTeamsListQueryKey(),
				(_context) => getPauseReasonsListQueryKey(),
			],
		}),
		assigned: defineQueryEndpoint<
			PagedResultOfTeamPauseReasonResponse,
			{ teamId: number },
			ListQueryParams
		>({
			key: 'teams.relations.pauseReasons.assigned',
			method: 'GET',
			path: '/admin/teams/{teamId}/pausereasons',
			pathParams: ['teamId'] as const,
			queryKey: (args) =>
				getTeamsRelationsPauseReasonsAssignedQueryKey(
					args?.pathParams?.teamId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getTeamsRelationsPauseReasonsAssignedQueryOptions(
					args?.pathParams?.teamId,
					args?.queryParams,
				),
		}),
		available: defineQueryEndpoint<
			PagedResultOfPauseReasonSummary,
			{ teamId: number },
			ListQueryParams
		>({
			key: 'teams.relations.pauseReasons.available',
			method: 'GET',
			path: '/admin/teams/{teamId}/assignable-pausereasons',
			pathParams: ['teamId'] as const,
			queryKey: (args) =>
				getTeamsRelationsPauseReasonsAvailableQueryKey(
					args?.pathParams?.teamId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getTeamsRelationsPauseReasonsAvailableQueryOptions(
					args?.pathParams?.teamId,
					args?.queryParams,
				),
		}),
		unassign: defineMutationEndpoint<
			void,
			(number | string)[],
			{ teamId: number }
		>({
			key: 'teams.relations.pauseReasons.unassign',
			method: 'DELETE',
			path: '/admin/teams/{teamId}/pausereasons',
			pathParams: ['teamId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					teamId: number | string | null | undefined
					data: (number | string)[]
				}) =>
					teamsRelationsPauseReasonsUnassign(variables.teamId, variables.data),
			}),
			invalidates: [
				(context) =>
					getTeamsRelationsPauseReasonsAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getTeamsRelationsPauseReasonsAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getTeamsListQueryKey(),
				(_context) => getPauseReasonsListQueryKey(),
			],
		}),
	},
} as const
// #endregion

// #region Relation: Queues
// Target Entity: queues
const teamsQueuesRelation = {
	key: 'queues',
	targetEntity: 'queues',
	endpoints: {
		assign: defineMutationEndpoint<
			TeamQueueResponse[],
			(number | string)[],
			{ teamId: number }
		>({
			key: 'teams.relations.queues.assign',
			method: 'POST',
			path: '/admin/teams/{teamId}/queues',
			pathParams: ['teamId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					teamId: number | string | null | undefined
					data: (number | string)[]
				}) => teamsRelationsQueuesAssign(variables.teamId, variables.data),
			}),
			invalidates: [
				(context) =>
					getTeamsRelationsQueuesAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getTeamsRelationsQueuesAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getTeamsListQueryKey(),
				(_context) => getQueuesListQueryKey(),
			],
		}),
		assigned: defineQueryEndpoint<
			PagedResultOfTeamQueueResponse,
			{ teamId: number },
			ListQueryParams
		>({
			key: 'teams.relations.queues.assigned',
			method: 'GET',
			path: '/admin/teams/{teamId}/queues',
			pathParams: ['teamId'] as const,
			queryKey: (args) =>
				getTeamsRelationsQueuesAssignedQueryKey(
					args?.pathParams?.teamId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getTeamsRelationsQueuesAssignedQueryOptions(
					args?.pathParams?.teamId,
					args?.queryParams,
				),
		}),
		available: defineQueryEndpoint<
			PagedResultOfQueueSummary,
			{ teamId: number },
			ListQueryParams
		>({
			key: 'teams.relations.queues.available',
			method: 'GET',
			path: '/admin/teams/{teamId}/assignable-queues',
			pathParams: ['teamId'] as const,
			queryKey: (args) =>
				getTeamsRelationsQueuesAvailableQueryKey(
					args?.pathParams?.teamId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getTeamsRelationsQueuesAvailableQueryOptions(
					args?.pathParams?.teamId,
					args?.queryParams,
				),
		}),
		unassign: defineMutationEndpoint<
			void,
			(number | string)[],
			{ teamId: number }
		>({
			key: 'teams.relations.queues.unassign',
			method: 'DELETE',
			path: '/admin/teams/{teamId}/queues',
			pathParams: ['teamId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					teamId: number | string | null | undefined
					data: (number | string)[]
				}) => teamsRelationsQueuesUnassign(variables.teamId, variables.data),
			}),
			invalidates: [
				(context) =>
					getTeamsRelationsQueuesAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getTeamsRelationsQueuesAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getTeamsListQueryKey(),
				(_context) => getQueuesListQueryKey(),
			],
		}),
		update: defineMutationEndpoint<
			TeamQueueResponse,
			UpdateTeamQueueRequest,
			{ teamId: number; mappingId: number }
		>({
			key: 'teams.relations.queues.update',
			method: 'PUT',
			path: '/admin/teams/{teamId}/queues/{mappingId}',
			pathParams: ['teamId', 'mappingId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					teamId: number | string | null | undefined
					mappingId: number | string | null | undefined
					data: UpdateTeamQueueRequest
				}) =>
					teamsRelationsQueuesUpdate(
						variables.teamId,
						variables.mappingId,
						variables.data,
					),
			}),
			invalidates: [
				(context) =>
					getTeamsRelationsQueuesAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getTeamsRelationsQueuesAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getTeamsListQueryKey(),
				(_context) => getQueuesListQueryKey(),
			],
		}),
	},
} as const
// #endregion

// #region Relation: SkillGroups
// Target Entity: skillGroups
const teamsSkillGroupsRelation = {
	key: 'skillGroups',
	targetEntity: 'skillGroups',
	endpoints: {
		assign: defineMutationEndpoint<
			TeamSkillGroupResponse[],
			(number | string)[],
			{ teamId: number }
		>({
			key: 'teams.relations.skillGroups.assign',
			method: 'POST',
			path: '/admin/teams/{teamId}/skillgroups',
			pathParams: ['teamId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					teamId: number | string | null | undefined
					data: (number | string)[]
				}) => teamsRelationsSkillGroupsAssign(variables.teamId, variables.data),
			}),
			invalidates: [
				(context) =>
					getTeamsRelationsSkillGroupsAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getTeamsRelationsSkillGroupsAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getTeamsListQueryKey(),
				(_context) => getSkillGroupsListQueryKey(),
			],
		}),
		assigned: defineQueryEndpoint<
			PagedResultOfTeamSkillGroupResponse,
			{ teamId: number },
			ListQueryParams
		>({
			key: 'teams.relations.skillGroups.assigned',
			method: 'GET',
			path: '/admin/teams/{teamId}/skillgroups',
			pathParams: ['teamId'] as const,
			queryKey: (args) =>
				getTeamsRelationsSkillGroupsAssignedQueryKey(
					args?.pathParams?.teamId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getTeamsRelationsSkillGroupsAssignedQueryOptions(
					args?.pathParams?.teamId,
					args?.queryParams,
				),
		}),
		available: defineQueryEndpoint<
			PagedResultOfSkillGroupSummary,
			{ teamId: number },
			ListQueryParams
		>({
			key: 'teams.relations.skillGroups.available',
			method: 'GET',
			path: '/admin/teams/{teamId}/assignable-skillgroups',
			pathParams: ['teamId'] as const,
			queryKey: (args) =>
				getTeamsRelationsSkillGroupsAvailableQueryKey(
					args?.pathParams?.teamId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getTeamsRelationsSkillGroupsAvailableQueryOptions(
					args?.pathParams?.teamId,
					args?.queryParams,
				),
		}),
		unassign: defineMutationEndpoint<
			void,
			(number | string)[],
			{ teamId: number }
		>({
			key: 'teams.relations.skillGroups.unassign',
			method: 'DELETE',
			path: '/admin/teams/{teamId}/skillgroups',
			pathParams: ['teamId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					teamId: number | string | null | undefined
					data: (number | string)[]
				}) =>
					teamsRelationsSkillGroupsUnassign(variables.teamId, variables.data),
			}),
			invalidates: [
				(context) =>
					getTeamsRelationsSkillGroupsAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getTeamsRelationsSkillGroupsAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getTeamsListQueryKey(),
				(_context) => getSkillGroupsListQueryKey(),
			],
		}),
	},
} as const
// #endregion

// #region Relation: Skills
// Target Entity: skills
const teamsSkillsRelation = {
	key: 'skills',
	targetEntity: 'skills',
	endpoints: {
		assign: defineMutationEndpoint<
			TeamSkillResponse[],
			(number | string)[],
			{ teamId: number }
		>({
			key: 'teams.relations.skills.assign',
			method: 'POST',
			path: '/admin/teams/{teamId}/skills',
			pathParams: ['teamId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					teamId: number | string | null | undefined
					data: (number | string)[]
				}) => teamsRelationsSkillsAssign(variables.teamId, variables.data),
			}),
			invalidates: [
				(context) =>
					getTeamsRelationsSkillsAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getTeamsRelationsSkillsAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getTeamsListQueryKey(),
				(_context) => getSkillsListQueryKey(),
			],
		}),
		assigned: defineQueryEndpoint<
			PagedResultOfTeamSkillResponse,
			{ teamId: number },
			ListQueryParams
		>({
			key: 'teams.relations.skills.assigned',
			method: 'GET',
			path: '/admin/teams/{teamId}/skills',
			pathParams: ['teamId'] as const,
			queryKey: (args) =>
				getTeamsRelationsSkillsAssignedQueryKey(
					args?.pathParams?.teamId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getTeamsRelationsSkillsAssignedQueryOptions(
					args?.pathParams?.teamId,
					args?.queryParams,
				),
		}),
		available: defineQueryEndpoint<
			PagedResultOfSkillSummary,
			{ teamId: number },
			ListQueryParams
		>({
			key: 'teams.relations.skills.available',
			method: 'GET',
			path: '/admin/teams/{teamId}/assignable-skills',
			pathParams: ['teamId'] as const,
			queryKey: (args) =>
				getTeamsRelationsSkillsAvailableQueryKey(
					args?.pathParams?.teamId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getTeamsRelationsSkillsAvailableQueryOptions(
					args?.pathParams?.teamId,
					args?.queryParams,
				),
		}),
		unassign: defineMutationEndpoint<
			void,
			(number | string)[],
			{ teamId: number }
		>({
			key: 'teams.relations.skills.unassign',
			method: 'DELETE',
			path: '/admin/teams/{teamId}/skills',
			pathParams: ['teamId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					teamId: number | string | null | undefined
					data: (number | string)[]
				}) => teamsRelationsSkillsUnassign(variables.teamId, variables.data),
			}),
			invalidates: [
				(context) =>
					getTeamsRelationsSkillsAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getTeamsRelationsSkillsAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getTeamsListQueryKey(),
				(_context) => getSkillsListQueryKey(),
			],
		}),
	},
} as const
// #endregion

// #region Relation: Templates
// Target Entity: templates
const teamsTemplatesRelation = {
	key: 'templates',
	targetEntity: 'templates',
	endpoints: {
		update: defineMutationEndpoint<
			void,
			undefined,
			{ teamId: number; templateId: number }
		>({
			key: 'teams.relations.templates.update',
			method: 'PUT',
			path: '/admin/teams/{teamId}/templates/{templateId}',
			pathParams: ['teamId', 'templateId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					teamId: number | string | null | undefined
					templateId: number | string | null | undefined
				}) =>
					teamsRelationsTemplatesUpdate(variables.teamId, variables.templateId),
			}),
			invalidates: [
				(_context) => getTeamsListQueryKey(),
				(_context) => getTemplatesListQueryKey(),
			],
		}),
	},
} as const
// #endregion

// #region Relation: Users
// Target Entity: users
const teamsUsersRelation = {
	key: 'users',
	targetEntity: 'users',
	endpoints: {
		assign: defineMutationEndpoint<
			TeamUserDto[],
			(number | string)[],
			{ teamId: number }
		>({
			key: 'teams.relations.users.assign',
			method: 'POST',
			path: '/admin/teams/{teamId}/users',
			pathParams: ['teamId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					teamId: number | string | null | undefined
					data: (number | string)[]
				}) => teamsRelationsUsersAssign(variables.teamId, variables.data),
			}),
			invalidates: [
				(context) =>
					getTeamsRelationsUsersAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getTeamsRelationsUsersAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getTeamsListQueryKey(),
				(_context) => getUsersListQueryKey(),
			],
		}),
		assigned: defineQueryEndpoint<
			PagedResultOfTeamUserDto,
			{ teamId: number },
			ListQueryParams
		>({
			key: 'teams.relations.users.assigned',
			method: 'GET',
			path: '/admin/teams/{teamId}/users',
			pathParams: ['teamId'] as const,
			queryKey: (args) =>
				getTeamsRelationsUsersAssignedQueryKey(
					args?.pathParams?.teamId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getTeamsRelationsUsersAssignedQueryOptions(
					args?.pathParams?.teamId,
					args?.queryParams,
				),
		}),
		available: defineQueryEndpoint<
			PagedResultOfUserDto,
			{ teamId: number },
			ListQueryParams
		>({
			key: 'teams.relations.users.available',
			method: 'GET',
			path: '/admin/teams/{teamId}/assignable-users',
			pathParams: ['teamId'] as const,
			queryKey: (args) =>
				getTeamsRelationsUsersAvailableQueryKey(
					args?.pathParams?.teamId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getTeamsRelationsUsersAvailableQueryOptions(
					args?.pathParams?.teamId,
					args?.queryParams,
				),
		}),
		unassign: defineMutationEndpoint<
			void,
			(number | string)[],
			{ teamId: number }
		>({
			key: 'teams.relations.users.unassign',
			method: 'DELETE',
			path: '/admin/teams/{teamId}/users',
			pathParams: ['teamId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					teamId: number | string | null | undefined
					data: (number | string)[]
				}) => teamsRelationsUsersUnassign(variables.teamId, variables.data),
			}),
			invalidates: [
				(context) =>
					getTeamsRelationsUsersAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getTeamsRelationsUsersAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getTeamsListQueryKey(),
				(_context) => getUsersListQueryKey(),
			],
		}),
	},
} as const
// #endregion
// #endregion

// #region Settings
const teamsSettings = {
	key: 'settings',
	defaultSection: 'contact',
	sections: {
		contact: {
			key: 'contact',
			endpoints: {
				load: defineQueryEndpoint<
					ContactSettingsDto,
					{ teamId: number },
					undefined
				>({
					key: 'teams.settings.contact.load',
					method: 'GET',
					path: '/admin/teams/{teamId}/settings/contact',
					pathParams: ['teamId'] as const,
					queryKey: (args) =>
						getTeamsSettingsContactLoadQueryKey(args?.pathParams?.teamId),
					queryOptions: (args) =>
						getTeamsSettingsContactLoadQueryOptions(args?.pathParams?.teamId),
				}),
				reset: defineMutationEndpoint<
					ContactSettingsDto,
					undefined,
					{ teamId: number }
				>({
					key: 'teams.settings.contact.reset',
					method: 'DELETE',
					path: '/admin/teams/{teamId}/settings/contact',
					pathParams: ['teamId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							teamId: number | string | null | undefined
						}) => teamsSettingsContactReset(variables.teamId),
					}),
					invalidates: [
						(context) =>
							getTeamsSettingsContactLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getTeamsListQueryKey(),
						(context) =>
							getTeamsDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
				update: defineMutationEndpoint<
					ContactSettingsDto,
					CreateOrUpdateContactSettingsRequest,
					{ teamId: number }
				>({
					key: 'teams.settings.contact.update',
					method: 'PUT',
					path: '/admin/teams/{teamId}/settings/contact',
					pathParams: ['teamId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							teamId: number | string | null | undefined
							data: CreateOrUpdateContactSettingsRequest
						}) => teamsSettingsContactUpdate(variables.teamId, variables.data),
					}),
					invalidates: [
						(context) =>
							getTeamsSettingsContactLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getTeamsListQueryKey(),
						(context) =>
							getTeamsDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
			},
		},
		general: {
			key: 'general',
			endpoints: {
				load: defineQueryEndpoint<
					GeneralSettingsDto,
					{ teamId: number },
					undefined
				>({
					key: 'teams.settings.general.load',
					method: 'GET',
					path: '/admin/teams/{teamId}/settings/general',
					pathParams: ['teamId'] as const,
					queryKey: (args) =>
						getTeamsSettingsGeneralLoadQueryKey(args?.pathParams?.teamId),
					queryOptions: (args) =>
						getTeamsSettingsGeneralLoadQueryOptions(args?.pathParams?.teamId),
				}),
				reset: defineMutationEndpoint<
					GeneralSettingsDto,
					undefined,
					{ teamId: number }
				>({
					key: 'teams.settings.general.reset',
					method: 'DELETE',
					path: '/admin/teams/{teamId}/settings/general',
					pathParams: ['teamId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							teamId: number | string | null | undefined
						}) => teamsSettingsGeneralReset(variables.teamId),
					}),
					invalidates: [
						(context) =>
							getTeamsSettingsGeneralLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getTeamsListQueryKey(),
						(context) =>
							getTeamsDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
				update: defineMutationEndpoint<
					GeneralSettingsDto,
					CreateOrUpdateGeneralSettingsRequest,
					{ teamId: number }
				>({
					key: 'teams.settings.general.update',
					method: 'PUT',
					path: '/admin/teams/{teamId}/settings/general',
					pathParams: ['teamId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							teamId: number | string | null | undefined
							data: CreateOrUpdateGeneralSettingsRequest
						}) => teamsSettingsGeneralUpdate(variables.teamId, variables.data),
					}),
					invalidates: [
						(context) =>
							getTeamsSettingsGeneralLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getTeamsListQueryKey(),
						(context) =>
							getTeamsDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
			},
		},
		login: {
			key: 'login',
			endpoints: {
				load: defineQueryEndpoint<
					LoginSettingsDto,
					{ teamId: number },
					undefined
				>({
					key: 'teams.settings.login.load',
					method: 'GET',
					path: '/admin/teams/{teamId}/settings/login',
					pathParams: ['teamId'] as const,
					queryKey: (args) =>
						getTeamsSettingsLoginLoadQueryKey(args?.pathParams?.teamId),
					queryOptions: (args) =>
						getTeamsSettingsLoginLoadQueryOptions(args?.pathParams?.teamId),
				}),
				reset: defineMutationEndpoint<
					LoginSettingsDto,
					undefined,
					{ teamId: number }
				>({
					key: 'teams.settings.login.reset',
					method: 'DELETE',
					path: '/admin/teams/{teamId}/settings/login',
					pathParams: ['teamId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							teamId: number | string | null | undefined
						}) => teamsSettingsLoginReset(variables.teamId),
					}),
					invalidates: [
						(context) =>
							getTeamsSettingsLoginLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getTeamsListQueryKey(),
						(context) =>
							getTeamsDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
				update: defineMutationEndpoint<
					LoginSettingsDto,
					CreateOrUpdateLoginSettingsRequest,
					{ teamId: number }
				>({
					key: 'teams.settings.login.update',
					method: 'PUT',
					path: '/admin/teams/{teamId}/settings/login',
					pathParams: ['teamId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							teamId: number | string | null | undefined
							data: CreateOrUpdateLoginSettingsRequest
						}) => teamsSettingsLoginUpdate(variables.teamId, variables.data),
					}),
					invalidates: [
						(context) =>
							getTeamsSettingsLoginLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getTeamsListQueryKey(),
						(context) =>
							getTeamsDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
			},
		},
		phone: {
			key: 'phone',
			endpoints: {
				load: defineQueryEndpoint<
					PhoneSettingsDto,
					{ teamId: number },
					undefined
				>({
					key: 'teams.settings.phone.load',
					method: 'GET',
					path: '/admin/teams/{teamId}/settings/phone',
					pathParams: ['teamId'] as const,
					queryKey: (args) =>
						getTeamsSettingsPhoneLoadQueryKey(args?.pathParams?.teamId),
					queryOptions: (args) =>
						getTeamsSettingsPhoneLoadQueryOptions(args?.pathParams?.teamId),
				}),
				reset: defineMutationEndpoint<
					PhoneSettingsDto,
					undefined,
					{ teamId: number }
				>({
					key: 'teams.settings.phone.reset',
					method: 'DELETE',
					path: '/admin/teams/{teamId}/settings/phone',
					pathParams: ['teamId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							teamId: number | string | null | undefined
						}) => teamsSettingsPhoneReset(variables.teamId),
					}),
					invalidates: [
						(context) =>
							getTeamsSettingsPhoneLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getTeamsListQueryKey(),
						(context) =>
							getTeamsDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
				update: defineMutationEndpoint<
					PhoneSettingsDto,
					CreateOrUpdatePhoneSettingsRequest,
					{ teamId: number }
				>({
					key: 'teams.settings.phone.update',
					method: 'PUT',
					path: '/admin/teams/{teamId}/settings/phone',
					pathParams: ['teamId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							teamId: number | string | null | undefined
							data: CreateOrUpdatePhoneSettingsRequest
						}) => teamsSettingsPhoneUpdate(variables.teamId, variables.data),
					}),
					invalidates: [
						(context) =>
							getTeamsSettingsPhoneLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getTeamsListQueryKey(),
						(context) =>
							getTeamsDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
			},
		},
		recording: {
			key: 'recording',
			endpoints: {
				load: defineQueryEndpoint<
					RecordingSettingsDto,
					{ teamId: number },
					undefined
				>({
					key: 'teams.settings.recording.load',
					method: 'GET',
					path: '/admin/teams/{teamId}/settings/recording',
					pathParams: ['teamId'] as const,
					queryKey: (args) =>
						getTeamsSettingsRecordingLoadQueryKey(args?.pathParams?.teamId),
					queryOptions: (args) =>
						getTeamsSettingsRecordingLoadQueryOptions(args?.pathParams?.teamId),
				}),
				reset: defineMutationEndpoint<
					RecordingSettingsDto,
					undefined,
					{ teamId: number }
				>({
					key: 'teams.settings.recording.reset',
					method: 'DELETE',
					path: '/admin/teams/{teamId}/settings/recording',
					pathParams: ['teamId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							teamId: number | string | null | undefined
						}) => teamsSettingsRecordingReset(variables.teamId),
					}),
					invalidates: [
						(context) =>
							getTeamsSettingsRecordingLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getTeamsListQueryKey(),
						(context) =>
							getTeamsDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
				update: defineMutationEndpoint<
					RecordingSettingsDto,
					CreateOrUpdateRecordingSettingsRequest,
					{ teamId: number }
				>({
					key: 'teams.settings.recording.update',
					method: 'PUT',
					path: '/admin/teams/{teamId}/settings/recording',
					pathParams: ['teamId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							teamId: number | string | null | undefined
							data: CreateOrUpdateRecordingSettingsRequest
						}) =>
							teamsSettingsRecordingUpdate(variables.teamId, variables.data),
					}),
					invalidates: [
						(context) =>
							getTeamsSettingsRecordingLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getTeamsListQueryKey(),
						(context) =>
							getTeamsDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
			},
		},
		setclip: {
			key: 'setclip',
			endpoints: {
				load: defineQueryEndpoint<
					SetClipSettingsDto,
					{ teamId: number },
					undefined
				>({
					key: 'teams.settings.setclip.load',
					method: 'GET',
					path: '/admin/teams/{teamId}/settings/setclip',
					pathParams: ['teamId'] as const,
					queryKey: (args) =>
						getTeamsSettingsSetclipLoadQueryKey(args?.pathParams?.teamId),
					queryOptions: (args) =>
						getTeamsSettingsSetclipLoadQueryOptions(args?.pathParams?.teamId),
				}),
				reset: defineMutationEndpoint<
					SetClipSettingsDto,
					undefined,
					{ teamId: number }
				>({
					key: 'teams.settings.setclip.reset',
					method: 'DELETE',
					path: '/admin/teams/{teamId}/settings/setclip',
					pathParams: ['teamId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							teamId: number | string | null | undefined
						}) => teamsSettingsSetclipReset(variables.teamId),
					}),
					invalidates: [
						(context) =>
							getTeamsSettingsSetclipLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getTeamsListQueryKey(),
						(context) =>
							getTeamsDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
				update: defineMutationEndpoint<
					SetClipSettingsDto,
					CreateOrUpdateSetClipSettingsRequest,
					{ teamId: number }
				>({
					key: 'teams.settings.setclip.update',
					method: 'PUT',
					path: '/admin/teams/{teamId}/settings/setclip',
					pathParams: ['teamId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							teamId: number | string | null | undefined
							data: CreateOrUpdateSetClipSettingsRequest
						}) => teamsSettingsSetclipUpdate(variables.teamId, variables.data),
					}),
					invalidates: [
						(context) =>
							getTeamsSettingsSetclipLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getTeamsListQueryKey(),
						(context) =>
							getTeamsDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
			},
		},
	},
} as const
// #endregion

// #region Client Endpoints
const teamsClientEndpoints = {
	get: defineQueryEndpoint<TeamUserDto[], undefined, undefined>({
		key: 'teams.client.get',
		method: 'GET',
		path: '/api/teams',
		queryKey: (_args) => getTeamsClientGetQueryKey(),
		queryOptions: (_args) => getTeamsClientGetQueryOptions(),
	}),
} as const
// #endregion

// #region Entity Config Export
export const teamsEntityConfig = {
	key: 'teams',
	kind: 'entity',
	entity: {
		idField: 'id',
		idParam: 'teamId',
		routePath: '/teams',
	},
	endpoints: teamsEntityEndpoints,
	relations: {
		customPages: teamsCustomPagesRelation,
		pauseReasons: teamsPauseReasonsRelation,
		queues: teamsQueuesRelation,
		skillGroups: teamsSkillGroupsRelation,
		skills: teamsSkillsRelation,
		templates: teamsTemplatesRelation,
		users: teamsUsersRelation,
	},
	settings: teamsSettings,
	client: teamsClientEndpoints,
} as const satisfies EntityConfig<'teams'>
// #endregion
